
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.12 12.04C20.62 11.99 21 11.56 21 11.05C21 10.46 20.49 9.99002 19.9 10.05C18.4 10.2 17 10.66 15.74 11.35L17.22 12.83C18.12 12.42 19.09 12.14 20.12 12.04ZM21 15.09C21 14.48 20.46 14 19.86 14.09C19.48 14.15 19.11 14.25 18.75 14.37L20.37 15.99C20.74 15.84 21 15.5 21 15.09ZM13.97 4.14002C14.03 3.55002 13.57 3.03002 12.97 3.03002C12.47 3.03002 12.03 3.40002 11.98 3.90002C11.88 4.93002 11.6 5.91002 11.19 6.81002L12.67 8.29002C13.36 7.03002 13.82 5.63002 13.97 4.14002ZM9.93003 4.16002C10.03 3.56002 9.54003 3.02002 8.93003 3.02002C8.52003 3.02002 8.18003 3.28002 8.03003 3.64002L9.65003 5.26002C9.78003 4.91002 9.87003 4.54002 9.93003 4.16002ZM20.44 18.88L5.12003 3.56002C4.73003 3.17002 4.10003 3.17002 3.71003 3.56002C3.32003 3.95002 3.32003 4.58002 3.71003 4.97002L5.86003 7.12002C5.27003 7.53002 4.60003 7.82002 3.87003 7.94002C3.39003 8.04002 3.03003 8.44002 3.03003 8.94002C3.03003 9.55002 3.57003 10.03 4.17003 9.94002C5.34003 9.75002 6.40003 9.26002 7.30003 8.57002L8.73003 10C7.39003 11.1 5.73003 11.82 3.92003 11.99C3.42003 12.04 3.04003 12.47 3.04003 12.98C3.04003 13.57 3.55003 14.04 4.14003 13.98C6.42003 13.75 8.50003 12.83 10.15 11.42L12.63 13.9C11.23 15.55 10.3 17.62 10.07 19.9C10.01 20.49 10.47 21.01 11.07 21.01C11.57 21.01 12.01 20.64 12.06 20.14C12.24 18.32 12.96 16.66 14.05 15.32L15.48 16.75C14.79 17.65 14.3 18.71 14.11 19.88C14.01 20.48 14.5 21.02 15.11 21.02C15.6 21.02 16.01 20.66 16.09 20.17C16.21 19.44 16.51 18.77 16.91 18.18L19.04 20.31C19.43 20.7 20.06 20.7 20.45 20.31C20.83 19.9 20.83 19.27 20.44 18.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-leak-remove`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLeakRemove

    ```js
    <b-new-b-icon-leak-remove />
    ```
</docs>


